import { render } from "./RecipeLike.vue?vue&type=template&id=09d8dfdd&scoped=true"
import script from "./RecipeLike.vue?vue&type=script&lang=js"
export * from "./RecipeLike.vue?vue&type=script&lang=js"

import "./RecipeLike.vue?vue&type=style&index=0&id=09d8dfdd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d8dfdd"]])

export default __exports__